import { Button } from "antd";
import { AddApiIntegrationForm } from "components/Forms/AddApiIntegrationForm/AddApiIntegrationForm";
import { Drawer } from "components/UI/Drawer";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { useDrawer } from "hooks/useDrawer.ts";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId, FormId } from "types/models.ts";

interface AddApiIntegrationDrawerProps {
    onSubmit: () => void;
}

export const AddApiIntegrationDrawer: FC<AddApiIntegrationDrawerProps> = ({ onSubmit }) => {
    const { t } = usePaldockTranslation("drawers.add-api-integration");
    const { t: tC } = usePaldockTranslation("common");
    const id = DrawerId.AddApiIntegration;
    const drawerUtils = useDrawer();

    const handleSubmit = () => {
        onSubmit?.();
        drawerUtils.hide(id);
    };

    return (
        <Drawer
            drawerId={id}
            title={<DrawerTitle mainTitle={t("title")} />}
            extraButtons={
                <Button htmlType={"submit"} type="primary" form={FormId.AddApiForm}>
                    {tC("save")}
                </Button>
            }
        >
            <div className={"w-100"}>
                <AddApiIntegrationForm onSubmit={handleSubmit} />
            </div>
        </Drawer>
    );
};
